import _ from 'lodash';

function getCancelPath(submission) {
    const accountNumber = _.get(submission, 'policy.accountNumber');
    const policyNumber = _.get(submission, 'policy.policyNumber');

    if (policyNumber) {
        return `/policies/${policyNumber}/claims`;
    }
    if (accountNumber) {
        return `/accounts/${accountNumber}/claims`;
    }
    return '/claims';
}

function prepareWC7Request(claimVM) {
    const claimValue = {
        lossDate: _.get(claimVM, 'lossDate'),
        lossType: _.get(claimVM, 'lossType'),
        lossCause: _.get(claimVM, 'lossCause'),
        lossLocation_Ext: _.get(claimVM, 'lossLocation_Ext'),
        description_Ext: _.get(claimVM, 'description_Ext'),
        policy: _.omit(claimVM.policy, ['offeringCode']),
        mainContact: null,
        claimNumber: _.get(claimVM, 'claimNumber'),
        reporter_Ext: _.get(claimVM, 'reporter_Ext'),
        typeOfClaim_Ext: _.get(claimVM, 'typeOfClaim_Ext'),
        lobs:
        {
            WC7WorkersComp_Ext: _.get(claimVM, 'lobs.wc7workersComp_Ext')
        }
    };
    return claimValue;
}

export default {
    getCancelPath, prepareWC7Request
};
